const GROUPVIEW = {
    listGroups: "Lista de grupos",
    newGroup: "Novo grupo",
  
    name: "Nome",
    description: "Descrição",
    company: "Companhia",
    state: "Doença",
    actions: "Ações",
  
    emptyGroups: "Não há grupos cadastrados.",
    groups: "Grupos",
  
    acept: "Aceitar",
    cancel: "Cancelar",
  
    DIALOGS: {
      titleDelete: `Excluir grupo: {description}`,
      textDelete: `Esta opção não pode ser desfeita, tem certeza?`
    },
  
    NOTIFY: {
      titleDeleteGorup: `Excluir grupos`,
      NotAutorization: `Você não tem permissões para executar esta ação.`,
      error: `Ocorreu um erro ao excluir o grupo`,
      goups: "Grupos",
      ActionUnavaliable: "Ação não disponível no momento."
    },
  
    remember: "Lembre-se de não usar <strong>caracteres especiais</strong>.",
    name: "Nome",
    save: "Salvar",
    clean: "Limpar"

};

export default { GROUPVIEW };